const QUERY_CACHE_KEY = 'SUPERFUNNEL_QUERY_CACHE';

export const safeLocalStorageSet = (key: string, value: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(key, value);
  } catch {
    window.localStorage.removeItem(QUERY_CACHE_KEY);

    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.error('[localStorage] Failed to persist value', { key, error });
    }
  }
};

export const safeLocalStorageRemove = (key: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error('[localStorage] Failed to remove value', { key, error });
  }
};

export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.error('[localStorage] Failed to read value', { key, error });
      return null;
    }
  },
  setItem: safeLocalStorageSet,
  removeItem: safeLocalStorageRemove,
};
